export const companyDescription =
  'Avenqor Talent Search is an executive search and talent advisory firm connecting organizations with senior executives, board members and specialized professionals.';
